import script from "./AdminConfigBranchesBranch.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigBranchesBranch.vue?vue&type=script&lang=ts&setup=true"

import "./AdminConfigBranchesBranch.vue?vue&type=style&index=0&id=6828cba6&lang=scss"

const __exports__ = script;

export default __exports__